const NONCE_BITS = 32;

const generateNonce = () => {
  // eslint-disable-next-line no-restricted-properties
  const nonce = Math.floor(Math.random() * Math.pow(2, NONCE_BITS));
  const hexNonce = nonce.toString(16);
  return hexNonce;
};

export default generateNonce;
